module.exports = __webpack_public_path__ + "img/VayaniF.02abf115.jpg";